import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const HowItWorksSection = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: '01',
      title: t('howItWorks.step1Title'),
      description: t('howItWorks.step1Desc'),
    },
    {
      number: '02',
      title: t('howItWorks.step2Title'),
      description: t('howItWorks.step2Desc'),
    },
    {
      number: '03',
      title: t('howItWorks.step3Title'),
      description: t('howItWorks.step3Desc'),
    },
  ];

  return (
    <section id="come-funziona" className="py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-[#0A0A0A]">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <span className="text-[#FFCC00] text-xs sm:text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
            Come Funziona
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white">
            Tre semplici passi
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.15 }}
              className="relative group"
            >
              {/* Large number watermark */}
              <span className="absolute -top-4 -left-2 text-[120px] font-heading font-bold text-[#FFCC00]/10 select-none pointer-events-none leading-none">
                {step.number}
              </span>
              
              <div className="relative bg-[#141414] border border-[#2A2A2A] p-8 h-full transition-all duration-300 group-hover:border-[#FFCC00] group-hover:shadow-[0_0_30px_rgba(255,204,0,0.1)]">
                <span className="text-[#FFCC00] text-sm font-semibold tracking-[0.2em] uppercase mb-4 block">
                  Step {step.number}
                </span>
                <h3 className="font-heading text-xl sm:text-2xl font-bold text-white mb-4">
                  {step.title}
                </h3>
                <p className="text-gray-400">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Alternative Option Banner */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 bg-[#141414] border border-[#2A2A2A] p-6 flex flex-col md:flex-row items-center justify-between gap-4"
        >
          <div className="flex items-center gap-4">
            <span className="text-3xl">💬</span>
            <div>
              <h4 className="text-white font-bold text-lg">Preferisci non prenotare online?</h4>
              <p className="text-gray-400 text-sm">Puoi anche scriverci su WhatsApp o venire direttamente in loco e pagare sul posto tramite il touch screen.</p>
            </div>
          </div>
          <a
            href="https://wa.me/393773781602?text=Ciao! Vorrei prenotare un locker"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 bg-[#25D366] text-white font-bold px-6 py-3 flex items-center gap-2 hover:bg-[#20bd5a] transition-colors"
          >
            <MessageCircle className="w-5 h-5" />
            Scrivici su WhatsApp
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
